import { supportedLocalesInclude } from "@/i18n/supported-locales";
import { getBrowserLocale } from "@/i18n/browser-locale";
export const getStartingLocale = () => {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true })
  return supportedLocalesInclude(browserLocale) ? browserLocale : 'en'
}
